const EditIcon = ({ size = '20px' }: { size?: string }) => (
  <img
    src="/assets/images/edit-icon.png"
    alt="Edit Icon"
    height={size}
    width={size}
    className="object-contain"
  />
);

export default EditIcon;
